<template>
<div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" ref="modal">
    <div class="modal-dialog modal-lg bg-white" role="document">
        <div class="modal-content py-11 px-10">
            <div class="modal-header">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <slot></slot>
        </div>
    </div>
</div>
</template>

<script>
export default {
    methods: {
        show () {
            $(this.$refs.modal).modal('show');
        },

        close () {
            $(this.$refs.modal).modal('hide');
        }
    }
}
</script>
